(function () {
  var overlay = document.querySelector('[data-oj-search-overlay]');
  if (!overlay) return;

  var triggers = document.querySelectorAll('[data-oj-search-trigger]');
  var closeButton = overlay.querySelector('[data-oj-search-close]');
  var form = overlay.querySelector('[data-oj-search-form]');
  var input = overlay.querySelector('[data-oj-search-input]');
  var suggestions = overlay.querySelector('[data-oj-search-suggestions]');
  var status = overlay.querySelector('[data-oj-search-status]');
  var results = overlay.querySelector('[data-oj-search-results]');
  var viewAll = overlay.querySelector('[data-oj-search-all]');
  var activeTrigger = null;
  var debounceTimer = null;
  var activeRequest = null;
  var lastQuery = '';

  if (!form || !input || !results || !viewAll) return;

  function rootPath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function searchUrl(query) {
    return rootPath() + 'search?q=' + encodeURIComponent(query) + '&type=product,article,page';
  }

  function suggestUrl(query) {
    var params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product,collection,page,article');
    params.set('resources[limit]', '6');
    params.set('resources[options][unavailable_products]', 'last');
    return rootPath() + 'search/suggest.json?' + params.toString();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function setTriggersExpanded(expanded) {
    triggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', String(expanded));
    });
  }

  function setStatus(message) {
    if (!status) return;
    if (message) {
      status.hidden = false;
      status.textContent = message;
    } else {
      status.hidden = true;
      status.textContent = '';
    }
  }

  function updateViewAll(query) {
    viewAll.href = query ? searchUrl(query) : rootPath() + 'search';
  }

  function openOverlay(trigger) {
    activeTrigger = trigger || activeTrigger;
    overlay.hidden = false;
    overlay.classList.add('is-open');
    setTriggersExpanded(true);
    window.setTimeout(function () {
      input.focus();
      input.select();
    }, 0);
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    setTriggersExpanded(false);
    setStatus('');
    if (activeRequest) {
      activeRequest.abort();
      activeRequest = null;
    }
    if (activeTrigger) {
      activeTrigger.focus();
    }
  }

  function normalizeImage(item) {
    if (!item) return '';
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    if (item.image && item.image.url) return item.image.url;
    if (typeof item.image === 'string') return item.image;
    return '';
  }

  function resultTypeLabel(type) {
    if (type === 'product') return 'Proizvod';
    if (type === 'collection') return 'Kolekcija';
    if (type === 'article') return 'Članak';
    return 'Stranica';
  }

  function renderItem(item, type) {
    var label = resultTypeLabel(type);
    var title = item.title || item.name || '';
    var url = item.url || '#';
    var vendor = item.vendor || '';
    var imageUrl = type === 'product' ? normalizeImage(item) : '';
    var cta = type === 'product' ? 'Pogledaj model' : 'Otvori';
    var media = imageUrl
      ? '<span class="oj-search-overlay-result__media"><img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(title) + '" loading="lazy"></span>'
      : '<span class="oj-search-overlay-result__media oj-search-overlay-result__media--empty" aria-hidden="true"></span>';
    var meta = vendor ? '<span class="oj-search-overlay-result__vendor">' + escapeHtml(vendor) + '</span>' : '';

    return [
      '<a class="oj-search-overlay-result" href="' + escapeHtml(url) + '">',
      media,
      '<span class="oj-search-overlay-result__body">',
      '<span class="oj-search-overlay-result__type">' + label + '</span>',
      meta,
      '<span class="oj-search-overlay-result__title">' + escapeHtml(title) + '</span>',
      '</span>',
      '<span class="oj-search-overlay-result__cta">' + cta + '</span>',
      '</a>'
    ].join('');
  }

  function flattenResults(payload) {
    var resources = payload && payload.resources && payload.resources.results ? payload.resources.results : {};
    var items = [];

    ['products', 'collections', 'pages', 'articles'].forEach(function (key) {
      var type = key === 'products' ? 'product' : key.replace(/s$/, '');
      (resources[key] || []).forEach(function (item) {
        items.push({ item: item, type: type });
      });
    });

    return items;
  }

  function renderResults(payload, query) {
    var items = flattenResults(payload);
    updateViewAll(query);
    setStatus('');

    if (suggestions) {
      suggestions.hidden = true;
    }

    if (!items.length) {
      results.innerHTML = '<p class="oj-search-overlay__empty">Nema brzih rezultata. Pokušajte punu pretragu.</p>';
      return;
    }

    results.innerHTML = items.map(function (entry) {
      return renderItem(entry.item, entry.type);
    }).join('');
  }

  function resetResults() {
    if (activeRequest) {
      activeRequest.abort();
      activeRequest = null;
    }
    lastQuery = '';
    results.innerHTML = '';
    setStatus('');
    updateViewAll('');
    if (suggestions) {
      suggestions.hidden = false;
    }
  }

  function requestSuggestions(query) {
    if (activeRequest) {
      activeRequest.abort();
    }

    var request = new AbortController();
    activeRequest = request;
    setStatus('Učitavanje...');

    fetch(suggestUrl(query), { signal: request.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Predictive search request failed');
        return response.json();
      })
      .then(function (payload) {
        renderResults(payload, query);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        setStatus('');
        results.innerHTML = '<p class="oj-search-overlay__empty">Nema brzih rezultata. Pokušajte punu pretragu.</p>';
        updateViewAll(query);
      })
      .finally(function () {
        if (activeRequest === request) {
          activeRequest = null;
        }
      });
  }

  function onInput() {
    var query = input.value.trim();
    window.clearTimeout(debounceTimer);
    updateViewAll(query);

    if (query.length < 2) {
      resetResults();
      return;
    }

    debounceTimer = window.setTimeout(function () {
      if (query === lastQuery) return;
      lastQuery = query;
      requestSuggestions(query);
    }, 250);
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openOverlay(trigger);
    });
  });

  if (closeButton) {
    closeButton.addEventListener('click', closeOverlay);
  }

  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) {
      closeOverlay();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !overlay.hidden) {
      closeOverlay();
    }
  });

  document.addEventListener('click', function (event) {
    if (overlay.hidden) return;
    if (overlay.contains(event.target)) return;
    if (event.target && event.target.closest('[data-oj-search-trigger]')) return;
    closeOverlay();
  });

  input.addEventListener('input', onInput);

  form.addEventListener('submit', function (event) {
    var query = input.value.trim();
    if (!query) {
      event.preventDefault();
      input.focus();
      return;
    }
    form.action = rootPath() + 'search';
  });

  overlay.querySelectorAll('[data-oj-search-chip]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      input.value = chip.getAttribute('data-oj-search-chip') || chip.textContent;
      input.focus();
      onInput();
    });
  });

  results.addEventListener('click', function (event) {
    var link = event.target && event.target.closest('a');
    if (link) {
      closeOverlay();
    }
  });

  updateViewAll('');
})();
